import { useMemo, useState, useEffect } from "react";
import ReactCountryFlag from "react-country-flag";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import Cart from "../../../../../public/images/Cart";
import SearchIcon from "../../../../../public/images/SearchIcon";
import { Countries } from "./country";
import useStore from "./useStore"; 
import "./countriesModal.scss";
import CountryDetails from "./CountryDetails"; 
import ArrowCart from "../../../../../public/images/ArrowCart";

function countEnabledNumberTypes(options) {
  if (!options || typeof options !== "object") return 0;

  return Object.values(options).filter((type) => {
    if (!type || typeof type !== "object") return false;

    return (
      type.activation?.enabled === true ||
      type.monthly?.enabled === true ||
      type.outboundRate?.enabled === true ||
      type.inboundRate?.enabled === true
    );
  }).length;
}

export default function CountriesModal({ open, onClose, onPick, onBuy }) {
  const [query, setQuery] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const { cart } = useStore();  
  const cartCount = cart.length; 

  const countries = Countries.countries || [];

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return countries;

    return countries.filter((c) => {
      const name = (c.name || "").toLowerCase();
      const code = (c.shortName || "").toLowerCase();
      return name.includes(q) || code.includes(q);
    });
  }, [countries, query]);

  useEffect(() => {
    if (!open) {
      setQuery("");
      setSelectedCountry(null);
    }
  }, [open]);
  const isCountryInCart = (countryId) => {
    return cart.some(item => item.country.id === countryId);
  };

  if (!open) return null;

  return (
    <div className="countriesModal__backdrop">
      <div className="countriesModal" onMouseDown={(e) => e.stopPropagation()}>
        {selectedCountry ? (
          <CountryDetails
            country={{
              ...selectedCountry,
              iso2: selectedCountry.shortName,
            }}
            onBack={() => setSelectedCountry(null)}
            onBuy={(country) => {
              setSelectedCountry(null); 
              onBuy?.(country); 
            }}
          />
        ) : (
          <div className="countriesModal__countries">
            <h2>Add Numbers</h2>

            <div className="countriesModal__countries__search">
              <h3>Numbers of which country do you need?</h3>

              <div className="countriesModal__countries__search__searchInput">
                <SearchIcon />
                <input
                  type="search"
                  placeholder="Start typing..."
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  autoFocus
                />
              </div>
            </div>

            <div className="countriesModal__countries__list">
              <SimpleBar style={{ maxHeight: "62vh" }}>
                {filtered.map((c) => {
                  const typesCount = countEnabledNumberTypes(c.options);

                  return (
                    <div key={c.id} className="countriesModal__countries__list__item">
                      <ReactCountryFlag
                        className="countriesModal__countries__list__item__image"
                        countryCode={c.shortName}
                        svg
                      />

                      <div className="countriesModal__countries__list__item__itemText">
                        <p>{c.name}</p>
                        <span>{typesCount} types numbers</span>
                      </div>
                      {isCountryInCart(c.id) && (
                        <span className="countriesModal__countries__list__item__checkmark"><ArrowCart/> </span>
                      )}
                      <button
                        type="button"
                        onMouseDown={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setSelectedCountry(c); 
                        }}
                      >
                       Buy now
                      </button>
                    </div>
                  );
                })}
              </SimpleBar>

              {filtered.length === 0 && (
                <div className="countriesModal__countries__empty">
                  No countries found for “{query.trim()}”
                </div>
              )}
            </div>
          </div>
        )}

        <div className="countriesModal__cart">
          <button>
            <Cart />
            <span>{cartCount}</span> 
          </button>
        </div>
      </div>
    </div>
  );
}